import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import profileData from '../data/profileData.json';

const Skills = () => {
  const { skills } = profileData;

  const skillCategories = [
    { title: 'Programming Languages', items: skills.languages, color: 'bg-blue-100 text-blue-800' },
    { title: 'Frameworks', items: skills.frameworks, color: 'bg-green-100 text-green-800' },
    { title: 'Cloud Technologies', items: skills.cloud, color: 'bg-purple-100 text-purple-800' },
    { title: 'Databases', items: skills.databases, color: 'bg-orange-100 text-orange-800' },
    { title: 'Microservices', items: skills.microservices, color: 'bg-pink-100 text-pink-800' },
    { title: 'DevOps & CI/CD', items: skills.devops, color: 'bg-indigo-100 text-indigo-800' },
    { title: 'Testing', items: skills.testing, color: 'bg-teal-100 text-teal-800' }
  ];

  return (
    <div className="min-h-screen pt-24 pb-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="mb-12">
          <h1 className="text-4xl font-bold text-[#1e3a5f] mb-4">Technical Skills</h1>
          <div className="h-1 w-20 bg-[#2563eb]"></div>
          <p className="mt-6 text-lg text-gray-600">
            Comprehensive expertise across modern technologies, frameworks, and development practices.
          </p>
        </div>

        {/* Skills Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {skillCategories.map((category, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow duration-200">
              <CardHeader>
                <CardTitle className="text-xl text-[#1e3a5f]">{category.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="flex flex-wrap gap-2">
                  {category.items.map((skill, skillIndex) => (
                    <Badge
                      key={skillIndex}
                      className={`${category.color} px-3 py-1 text-sm font-medium`}
                      variant="secondary"
                    >
                      {skill}
                    </Badge>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Core Competencies */}
        <div className="mt-16">
          <h2 className="text-3xl font-bold text-[#1e3a5f] mb-8">Core Competencies</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Card className="bg-white">
              <CardContent className="pt-6">
                <h3 className="text-lg font-semibold text-[#1e3a5f] mb-3">Architecture & Design</h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• Microservices Architecture</li>
                  <li>• Event-Driven Architecture</li>
                  <li>• Domain Driven Design</li>
                  <li>• RESTful API Design</li>
                  <li>• Serverless Architecture</li>
                </ul>
              </CardContent>
            </Card>

            <Card className="bg-white">
              <CardContent className="pt-6">
                <h3 className="text-lg font-semibold text-[#1e3a5f] mb-3">Cloud & DevOps</h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• AWS Cloud Services</li>
                  <li>• CI/CD Pipelines</li>
                  <li>• Docker Containerization</li>
                  <li>• Infrastructure as Code</li>
                  <li>• Monitoring & Logging</li>
                </ul>
              </CardContent>
            </Card>

            <Card className="bg-white">
              <CardContent className="pt-6">
                <h3 className="text-lg font-semibold text-[#1e3a5f] mb-3">Development Practices</h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• Test-Driven Development</li>
                  <li>• Agile Methodologies</li>
                  <li>• Code Review & Quality</li>
                  <li>• Performance Optimization</li>
                  <li>• Technical Documentation</li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;